import csv from './rawCSVData'

export const yDomain = [0, 2500]
export const bikeWeight = 10
export const refWeight = 100 + bikeWeight
export const refAbility = 1.05
export const refCompliance = 1.0

export const testData = [
  {
    label: 'F4-PC1',
    data: [],
    lowerBound: [],
    upperBound: []
  },
  {
    label: 'F4-PC2',
    data: [],
    lowerBound: [],
    upperBound: []
  },
  {
    label: 'F4-PC3',
    data: [],
    lowerBound: [],
    upperBound: []
  },
  {
    label: 'F4-PC4',
    data: [],
    lowerBound: [],
    upperBound: []
  },
  {
    label: 'F4-PC5',
    data: [],
    lowerBound: [],
    upperBound: []
  },
]


const dataTypeMapping = {
  0: 'upperBound',
  1: 'data',
  2: 'lowerBound'
}
for (let i = 0; i < csv.length; i += 1) {
  const colIdx = i % 16
  if (colIdx === 0) continue // x value, unnecessary
  const valveIdx = Math.floor((colIdx - 1) / 3)
  const dataType = dataTypeMapping[(colIdx - 1) % 3]
  testData[valveIdx][dataType].push(csv[i])
}

export const benchmarkData = testData[4].data



// WEBPACK FOOTER //
// ./src/data.js